import { useEffect, useState, React, Fragment } from "react";
import Loading from "./loading";
import useAuth from "../context/useAuth";
import '../css/Toolsconvenioweb.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import NavBar from "./NavBar";
function Dashboard(props) {
  const { logout } = useAuth();
  const [dados, setDados] = useState([]);
  const [paginaCarregada, setPaginaCarregada] = useState(false);
  const [carregando, setCarregando] = useState(true);

  const ignorarIdGia = [137];

  useEffect(() => {
    const tokenAcesso = process.env.REACT_APP_MONGO_token;
    const requestOptions = {
      headers: { token: tokenAcesso }
    };

    fetch(process.env.REACT_APP_API_TCW, requestOptions)
      .then(dados => dados.json())
      .then(data => {
        setDados(data);
        setPaginaCarregada(true);
      })
      .catch(err => console.log(err))

  }, [])

  useEffect(() => {
    if (paginaCarregada) {
      setCarregando(false);
    }
  }, [paginaCarregada]);

  if (!paginaCarregada) {
    return <Loading />;
  }

  let totalExecutando = 0;
  let totalErro = 0;

  if (dados) {
    const dadosFiltrados = dados.filter((item) => {
      return (item.recursos.some(
        (recurso) =>
          recurso.recurso === 'MONITOR_CONVENIO_WEB' && recurso.status !== 'DESATIVADO' && !ignorarIdGia.includes(item._id))
      )
    })
    dadosFiltrados.forEach((item) => {
      item.recursos.forEach((recurso) => {
        if (recurso.recurso === 'MONITOR_CONVENIO_WEB' && recurso.status !== 'DESATIVADO') {
          totalExecutando++;
          if (recurso.status === 'ERRO') {
            totalErro++;
          }
        }
      });
    });
    return (
      <div className="menu">
        <NavBar />
        <div className="containerBox">

          <div className="flex flex-col pb-4 ">

            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              <div className="flex items-start rounded-xl  bg-emerald-400 p-4 shadow-md">
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-blue-100 bg-green-50 shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" />
                    <FontAwesomeIcon icon={faCheck} />
                  </svg>
                </div>
                <div className="ml-4">
                  <h2 className="font-semibold text-green-50 text-4xl">  {totalExecutando}</h2>
                  <p className="mt-2 text-sm text-green-50 font-semibold">Farmácias TCW
                  </p>
                </div>
              </div>
              <div className="flex items-start rounded-xl bg-red-500 p-4 shadow-md">
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-orange-100 bg-red-50 shadow-md">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" />
                    <FontAwesomeIcon icon={faXmark} />
                  </svg>
                </div>

                <div className="ml-4">
                  <h2 className="font-semibold text-red-50 text-4xl">{totalErro}</h2>
                  <p className="mt-2 text-sm font-semibold  text-red-50 bold">Com Erro</p>
                </div>
              </div>
            </div>
          </div>
          <table className="min-w-full divide-y divide-gray-200 overflow-x-auto">
            <thead style={{ backgroundColor: '#1E1E2E', fontFamily: 'Raleway' }}>
              <tr>
                <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider">ID Gia</th>
                <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider">Data Última Execução</th>
                <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider">Status</th>
                <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider">Info</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: '#27293D' }} className="divide-y divide-gray-200">

              {dadosFiltrados.map((item, index) => {
                item.recursos.forEach((recurso) => {
                  if (recurso.recurso === 'MONITOR_CONVENIO_WEB' && recurso.status !== 'DESATIVADO' && item._id && !ignorarIdGia.includes(item._id)) {
                    if (recurso.status === 'EXECUTANDO') {
                      totalExecutando++;
                    } else if (recurso.status === 'ERRO') {
                      totalErro++;
                    }
                  }
                });
                return (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap text-md font-bold  text-gray-50 ">{item._id}</td>
                    {item.recursos
                      .filter((recurso) => recurso.recurso === 'MONITOR_CONVENIO_WEB')
                      .map((recurso, recursoIndex) => (
                        <Fragment key={recursoIndex}>
                          <td className="text-sm font-medium text-gray-50">{recurso.dataUltimaExecucao}</td>
                          <td>
                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${recurso.status === 'ATIVADO' ? 'bg-emerald-400 text-green-50' : 'bg-red-500 text-red-50'
                              }`}>
                              {recurso.status}
                            </span>
                          </td>
                          <td className="text-sm font-medium text-gray-50">{recurso.mensagem}</td>
                        </Fragment>
                      ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  } else {
    return <div>falha ao carregar</div>;
  }


}
export default Dashboard;